const FALLBACK = "操作失敗，請稍後再試";

// axios 在後端沒有回傳 message 時的預設英文訊息,不適合直接顯示給使用者
const AXIOS_DEFAULT_MESSAGE = /^(Request failed with status code|Network Error$|timeout of|canceled$)/i;

interface ErrorLike {
  message?: unknown;
  code?: unknown;
  response?: { status?: unknown };
  isAxiosError?: unknown;
}

/** 回傳可直接顯示給使用者的錯誤訊息;不應提示時(取消/401)回傳 null */
export function getMutationErrorMessage(error: unknown): string | null {
  const e = (error && typeof error === "object" ? error : {}) as ErrorLike;
  const message = typeof e.message === "string" ? e.message.trim() : "";
  const status = typeof e.response?.status === "number" ? e.response.status : undefined;

  if (e.code === "ERR_CANCELED" || (error instanceof DOMException && error.name === "AbortError")) return null;
  // 401 由 http 層的 refresh / authFailureHandler 處理(會導回登入),不另外跳錯誤
  if (status === 401) return null;

  if (e.isAxiosError) {
    if (message && !AXIOS_DEFAULT_MESSAGE.test(message)) return message; // 後端 message / 驗證錯誤 / 429 訊息
    if (!e.response) return "無法連接到伺服器，請檢查網路連線";
    if (status !== undefined && status >= 500) return "伺服器錯誤，請稍後再試";
    return FALLBACK;
  }

  return message || FALLBACK;
}
